import React from "react";
import Attributes from "contexts/attributes/attributes";
import { AttributesModal } from "./attributes-modal";
import { TaskProvider } from "contexts/task";
import { ProfilingAttributeInput } from "./profiling-attribute-input";

export const ProfilingMainAttributes = ({
    upc,
    profilingTaskKey,
    productModifier,
    definitions,
    taskType,
    codingWipKey,
    isFinalized,
    isTaskCompleted,
    itemInfo,
    onRefetchDefinitions,
    onValidateGroupAttributes,
    readOnlyEdit,
    hasMissingSizeAttributes,
    showMissingSizeAttributes,
}) => {
    return (
        // TODO: why this provider is used like this? Refactor
        <TaskProvider
            value={{
                task: {
                    context: { codingWipKey: codingWipKey },
                    isCompleted: isFinalized,
                    sourcePage: "profiling",
                    key: profilingTaskKey,
                    taskType,
                },
            }}
        >
            <Attributes taskType={taskType}>
                <div className="column -span6">
                    {definitions
                        // TODO: refactor this filter method
                        .filter(
                            (attr) =>
                                attr.hiddenAttributeTaskInfo === null ||
                                (attr.hiddenAttributeTaskInfo && attr.hiddenAttributeTaskInfo.filter((n) => n === taskType).length === 0)
                        )
                        .map((attr) => {
                            return (
                                <ProfilingAttributeInput
                                    key={`field_${codingWipKey}_${attr.uuid}`}
                                    taskType={taskType}
                                    attribute={attr}
                                    codingWipKey={codingWipKey}
                                    taskKey={profilingTaskKey}
                                    fetchDefinitions={onRefetchDefinitions}
                                    isFinalized={readOnlyEdit || (itemInfo && itemInfo.state === "completed")}
                                    isCompleted={isFinalized || itemInfo?.state === "completed"}
                                />
                            );
                        })}
                    {definitions.length > 0 && (
                        <AttributesModal
                            upc={upc}
                            productModifier={productModifier}
                            codingWipKey={codingWipKey}
                            isFinalized={isFinalized}
                            isTaskCompleted={isTaskCompleted}
                            onValidateGroupAttributes={onValidateGroupAttributes}
                            readOnlyEdit={readOnlyEdit}
                            itemInfo={itemInfo}
                            hasMissingSizeAttributes={hasMissingSizeAttributes}
                            showMissingSizeAttributes={showMissingSizeAttributes}
                        />
                    )}
                </div>
            </Attributes>
        </TaskProvider>
    );
};
